// CSV/TSV header for the key-column picker. It MUST read the header exactly as
// the engine does: a picked name is passed to diffCsv as `keyColumn`, and a name
// the engine does not have is silently replaced by the auto-picked key. A
// hand-rolled first-line reader trimmed ` id `, stripped `'id'`, kept `""`
// doubled, cut a multiline quoted header at its newline and missed Papa's
// duplicate renaming (`name` → `name_1`) — each offered a choice that did nothing
// (REL-088). So this is the engine's own parse config, stopped after one row.
import Papa from 'papaparse';
import { csvParseConfig } from '../engine/csv-diff.js';

export function csvColumns(text, format = 'csv') {
  if (!(text || '').trim()) return [];
  const { meta } = Papa.parse(text, { ...csvParseConfig(format), preview: 1 });
  // An empty header cannot be chosen as a key (there is no name to select).
  return (meta.fields || []).filter((name) => name !== '');
}
